import { Content } from "@/services/content/types";

export const getUniqueArticles = (
  articles: Content.Article[],
  limit: number
) => {
  return Array.from(new Map(articles.map((a) => [a.sys.id, a])).values()).slice(
    0,
    limit
  );
};

export const getColor = (name?: string) =>
  ({
    Play: "bg-purple-500",
    Finansmagasinet: "bg-red-500",
    Podd: "bg-sand-800",
    Börs: "bg-sand-800",
    Krönika: "bg-sand-800",
    Helg: "bg-sand-800",
    Bok: "bg-yellow-500",
    Vetenskap: "bg-green-300",
    Default: "bg-sand-800",
  }[name || "Default"]);

export const getTextColor = (name?: string) =>
  ({
    Play: "text-purple-500",
    Finansmagasinet: "text-red-500",
    Podd: "text-black",
    Börs: "text-black",
    Krönika: "text-category-chronicles",
    Helg: "text-red-500",
    Default: "text-black",
  }[name || "Default"]);
